export default __webpack_public_path__ + "static/media/Logo.51b396b7.png";